import { useProductsLandingWrapper } from "./products-landing-wrapper.hook";
import { Error404 } from "../error-404/error-404";
import { LandingCL } from "./civil-liability-landing/landing-cl";
import { Navigate } from "react-router-dom";
import { LandingLP } from "./legal-protection-landing/landing-lp";
import OfficesStudios from "../offices-studios/offices-studios";
import { ProductsCodeMap } from "./products_mapping.utils";
import { MAX_WIDTH } from "src/config";

export const ProductsLadingWrapper = ({
  codProd,
}: {
  codProd: ProductsCodeMap;
}) => {
  const { dossier, selectedProduct, hasProducts, navigateToLandingString } =
    useProductsLandingWrapper({ codProd });

  if (!hasProducts) return <Navigate to={navigateToLandingString} />;

  if (!selectedProduct || !dossier.codProd || dossier.codProd != codProd)
    return <Error404 />;

  const viewByCode: Record<ProductsCodeMap, JSX.Element> = {
    [ProductsCodeMap.RC01]: <LandingCL />,
    [ProductsCodeMap.TL01]: <LandingLP />,
    [ProductsCodeMap.US01]: <OfficesStudios />,
  } as const;

  return (
    <div className="d-flex justify-content-center">
      <div style={{ maxWidth: MAX_WIDTH }}>{viewByCode[codProd] ?? <></>}</div>
    </div>
  );
};
